import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { PopupData } from './popup.service';

/** Component opened inside a snackbar. */
@Component({
    selector: 'ce-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
})
export class PopupSnackbarComponent {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: PopupData) {}
}
